<template>
    <LayoutHeader>
        <router-view v-slot="{ Component }">
            <transition
                name="pageTransition"
                mode="out-in"
            >
                <component :is="Component" />
            </transition>
        </router-view>
    </LayoutHeader>
</template>
<script>
import LayoutHeader from '@/components/layout/LayoutHeader.vue';

export default {
    components: {
        LayoutHeader
    },
};
</script>
<style scoped>
.pageTransition-enter-active,
.pageTransition-leave-active {
    transition: opacity 0.5s ease;
}

.pageTransition-enter-from,
.pageTransition-leave-to {
    opacity: 0;
}
</style>
